
import React from 'react';
import { Input } from 'reactstrap';

export var filterAssociation = {};


export function sortingDetails( columnName, theSortDirection ) {
	let objSortingDetails;

	if ( theSortDirection !== undefined ) {
		theSortDirection = theSortDirection[columnName];
	} else {
		theSortDirection = "down";
	}

	switch ( theSortDirection ) {
		case "up":
			objSortingDetails = {
				iconEntity: <img alt="sort-up" width="12px" src="sorting-up.svg" />,
				fn: (a, b) => {
					let aVal = a[columnName];
					let bVal = b[columnName];
					switch ( columnName ) {
						case "procedureDate":
						case "withdrawalDateTime":
						case "recordDateTime":
						case "receiveDateTime":
						case "qaCompleteDateTime":
						case "mdOverreadDateTime":
							aVal = "epoch: " + Date.parse( aVal );
							bVal = "epoch: " + Date.parse( bVal );
							break;
						default:
							break;
					}
					switch ( typeof aVal ) {
						case "symbol":
						case "object":
						case "function":
						case "undefined":
							aVal = "undefined";
							bVal = "undefined";
							break;
						case "bigint":
						case "number":
							aVal = "num:" + aVal;
							bVal = "num:" + bVal;
							break;
						case "boolean":
							aVal = (aVal ? "Yes" : "No");
							bVal = (bVal ? "Yes" : "No");
							break;
						default:
							break;
					}
					if ( aVal === null || aVal === undefined ) { aVal = ''; };
					if ( bVal === null || bVal === undefined ) { bVal = ''; };
					if ( aVal.toUpperCase() > bVal.toUpperCase() ) return 1;
					if ( aVal.toUpperCase() < bVal.toUpperCase() ) return -1;
					return 0;
				}
			};
			break;

		case "down":
			objSortingDetails = {
				iconEntity: <img alt="sort-down" width="12px" src="sorting-down.svg" />,
				fn: (a, b) => {
					let aVal = a[columnName];
					let bVal = b[columnName];
					switch ( columnName ) {
						case "procedureDate":
						case "withdrawalDateTime":
						case "recordDateTime":
						case "receiveDateTime":
						case "qaCompleteDateTime":
						case "mdOverreadDateTime":
							aVal = "epoch: " + Date.parse( aVal );
							bVal = "epoch: " + Date.parse( bVal );
							break;
						default:
							break;
					}
					switch ( typeof aVal ) {
						case "symbol":
						case "object":
						case "function":
						case "undefined":
							aVal = "undefined";
							bVal = "undefined";
							break;
						case "bigint":
						case "number":
							aVal = "num:" + aVal;
							bVal = "num:" + bVal;
							break;
						case "boolean":
							aVal = (aVal ? "Yes" : "No");
							bVal = (bVal ? "Yes" : "No");
							break;
						default:
							break;
					}
					if ( aVal === null || aVal === undefined ) { aVal = ''; };
					if ( bVal === null || bVal === undefined ) { bVal = ''; };
					if ( aVal.toUpperCase() < bVal.toUpperCase() ) return 1;
					if ( aVal.toUpperCase() > bVal.toUpperCase() ) return -1;
					return 0;
				}
			};
			break;

		default:
			objSortingDetails = {
				iconEntity: <img alt="sort-both" width="12px" src="sorting-both.svg" />,
				fn: (a, b) => { return 0; }
			};
			break;
	}

	return objSortingDetails;
}

export function filterData( lst, filters ) {
	return lst.filter( (row,idx) => {
		const colKeys = Object.keys(row);
		const filterKeys = Object.keys(filters);

		/* look through each column... */
		for ( var i = 0; i < colKeys.length; i++ ) {
			const thisColKey = filterAssociation[ colKeys[i] ];	/* switch between the pretty name and the record's key for the data in that column */
			const thisFilter = filters[thisColKey];

			/* look for a column that has a valid filter in it */
			if ( (thisFilter !== '') && filterKeys.indexOf(thisColKey) >= 0 ) {
				let rowVal = row[colKeys[i]];
				if ( rowVal === null ) {
					rowVal = ' ';
				}
				rowVal = rowVal.toUpperCase();

				let useDateCompareBefore = false;
				let useRegExp = false;
				if ( thisFilter.startsWith('.regexp.') ) {
					useRegExp = true;
				}
				if ( thisFilter.startsWith('.before.') ) {
					useDateCompareBefore = true;
				}

				/* if this filter's value is not a substring in this row's value for this column, then don't display this row */
				if ( useRegExp ) {
					try {
						let re = new RegExp(thisFilter.substr(8).trimLeft(), "i");
						if ( ! re.test(rowVal) ) {
							return null;
						}
					} catch (error) {
					}
				} else if ( useDateCompareBefore ) {
					let theDate = Date.parse(thisFilter.substr(8));
					if ( Date.parse(rowVal) >= theDate ) {
						return null;
					}
				} else {
					if ( ! rowVal.includes( thisFilter.toUpperCase() ) ) {
						return null;
					}
				}
			}
		}
		return row;
	});
}


export function toggleFilter() {
	if ( this.state.isShowingFilter ) {
		this.setState({ currentFilters: {} });
	}
	this.setState({ isShowingFilter: ! this.state.isShowingFilter });
}

export const ColHeader = (props) => {
	const className = "filter_input";
	if ( ! props.onSortChange ) {
		return (
			React.createElement(props.doGrid ? 'div' : 'th', { className: props.className + (props.doGrid ? " col" : "") },
				props.label
			)
		);
	} else
	if ( props.recordKey === '' ) {
		return( 
			React.createElement(props.doGrid ? 'div' : 'th', { className: props.className + (props.doGrid ? " col" : "") },
				<span>
					{props.label}
					{props.showFilter && 
						<span>
							<br />
							<br />
						</span>
					}
				</span>
			)
		);
	} else {
		var lblWords = props.label.split(" ");
		var lblMostWords = lblWords.splice(0, lblWords.length - 1).join(" ");
		var lblLastWord = lblWords.splice(-1)[0];
		return(
			React.createElement(props.doGrid ? 'div' : 'th', { className: props.className + (props.doGrid ? " col" : "") },
				<span>
					<span onClick={() => props.onSortChange(props.recordKey) }>
						{lblMostWords}
						<span className="nowrap"> {lblLastWord} {!props.doActions && !props.doAction && sortingDetails(props.recordKey,props.sortDir).iconEntity} </span>
					</span>
					{props.showFilter &&  !props.doActions && !props.doAction &&
						<span>
							<br />
							<Input id={props.label} name={props.label} key={"key_"+props.label} className={className} disabled={false} onChange={props.onChange} readOnly={false} type="text" value={props.value} />
						</span>
					}
					{props.showFilter && props.doActions &&
						<div className="billing-doActions">
							<span className="billing-select-all" onClick={props.onClick}> Select All </span>
							<br />
							<span className="billing-clear-all" onClick={props.onClick}> Clear All </span>
						</div>
					}
					{props.showFilter && props.doAction &&
						<div className="billing-doAction">
							<br />
							<br />
						</div>
					}
				</span>
			)
		);
	}
};





// WEBPACK FOOTER //
// ./src/data/SortFilter.js